"use client";

import React, { Suspense, lazy } from "react";
import { Card, Box, Typography, Grid } from "@mui/material";

const Chart = lazy(() => import("react-apexcharts"));

const InfluencedRevenueChart = ({ data = {}, breakdown = [] }) => {
    // Breakdown data for the chart
    const labels = breakdown.map((item) => item.name);
    const series = breakdown.map((item) => item.value);

    const options = {
        chart: { type: "donut" },
        labels: labels,
        colors: ["#605DFF", "#FFB264"], // Purple and Orange
        legend: { position: "bottom" },
        dataLabels: { enabled: true },
        plotOptions: {
            pie: {
                donut: {
                    size: "65%",
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: "Total Influenced",
                            color: "#64748B",
                            formatter: function (w) {
                                return "$" + w.globals.seriesTotals.reduce((a, b) => a + b, 0).toLocaleString();
                            },
                        },
                    },
                },
            },
        },
    };

    return (
        <Card
            sx={{
                boxShadow: "none",
                borderRadius: "7px",
                p: { xs: 2, sm: 3 },
                height: "100%",
                display: "flex",
                flexDirection: "column",
                position: "relative",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    bgcolor: "rgba(255, 255, 255, 0.6)",
                    zIndex: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backdropFilter: "blur(1px)",
                }}
            >
                <Typography variant="h5" fontWeight="bold" color="text.secondary">
                    Coming Soon...
                </Typography>
            </Box>
            <Typography variant="h6" fontWeight={700} mb={2}>
                Revenue Influenced
            </Typography>

            <Grid container spacing={2} mb={2}>
                <Grid size={{ xs: 6 }}>
                    <Box p={1.5} bgcolor="#F4F7FE" borderRadius="8px">
                        <Typography variant="caption" color="text.secondary">
                            Last Click (Overall)
                        </Typography>
                        <Typography variant="h6" fontWeight={700} color="#605DFF">
                            ${data.last_click?.toLocaleString()}
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{ xs: 6 }}>
                    <Box p={1.5} bgcolor="#FFF4E5" borderRadius="8px">
                        <Typography variant="caption" color="text.secondary">
                            Assisted Conversions
                        </Typography>
                        <Typography variant="h6" fontWeight={700} color="#FFB264">
                            ${data.assisted?.toLocaleString()}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

            <Box sx={{ flexGrow: 1, minHeight: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Suspense fallback={<div>Loading Chart...</div>}>
                    <Chart options={options} series={series} type="donut" height={280} width="100%" />
                </Suspense>
            </Box>
            <Typography variant="caption" textAlign="center" mt={2} color="text.secondary">
                Last Click vs Assisted Breakdown
            </Typography>
        </Card>
    );
};

export default InfluencedRevenueChart;
